// Helpers shared only by the two administrator popup forms.
export const popupHttps = (value) => {
  try {
    const url = new URL(value);
    return (
      value.length <= 2048 &&
      url.protocol === 'https:' &&
      !!url.hostname &&
      !url.username &&
      !url.password
    );
  } catch {
    return false;
  }
};
export const popupLocalDate = (value) => {
  if (!value) return '';
  const date = new Date(value);
  if (!Number.isFinite(date.getTime()))
    throw new Error('공개 기간 형식이 잘못되었습니다. 다시 불러와주세요.');
  return new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString().slice(0, 16);
};
export const popupDates = (value) => {
  for (const key of ['startsAt', 'endsAt']) popupLocalDate(value[key]);
  if (value.startsAt && value.endsAt && Date.parse(value.startsAt) >= Date.parse(value.endsAt))
    throw new Error('종료 시각은 시작 시각보다 늦어야 합니다.');
};
export const popupRecord = (value) => {
  if (
    !value ||
    typeof value !== 'object' ||
    Array.isArray(value) ||
    typeof value.enabled !== 'boolean' ||
    typeof value.title !== 'string'
  )
    throw new Error('설정 응답을 확인할 수 없습니다. 다시 불러와주세요.');
  popupDates(value);
  return value;
};
export const miniRecord = (value) => ({
  ...popupRecord(value),
  titleEn: value.titleEn || '',
  imageUrl: value.imageUrl || '',
  destinationUrl: value.destinationUrl || '',
  backgroundColor: value.backgroundColor || '#F16438',
  textColor: value.textColor || '#111111',
});
export const validateMini = (value) => {
  if (
    value.title.length > 100 ||
    value.titleEn.length > 100 ||
    (value.enabled && !value.title.trim())
  )
    throw new Error('미니 팝업 문구는 1~100자입니다.');
  if (
    (value.enabled && !value.destinationUrl) ||
    [value.imageUrl, value.destinationUrl].filter(Boolean).some((url) => !popupHttps(url))
  )
    throw new Error('유효한 HTTPS 주소를 입력하세요.');
  if (![value.backgroundColor, value.textColor].every((c) => /^#[\da-f]{6}$/i.test(c)))
    throw new Error('색상은 #RRGGBB 형식입니다.');
  const luminance = (hex) =>
    [1, 3, 5]
      .map((i) => parseInt(hex.slice(i, i + 2), 16) / 255)
      .map((c) => (c <= 0.04045 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4))
      .reduce((n, c, i) => n + c * [0.2126, 0.7152, 0.0722][i], 0);
  const bg = luminance(value.backgroundColor),
    fg = luminance(value.textColor);
  if ((Math.max(bg, fg) + 0.05) / (Math.min(bg, fg) + 0.05) < 4.5)
    throw new Error('문구 가독성을 위해 배경색과 글자색 대비를 높여주세요 (4.5:1 이상).');
  popupDates(value);
};
